import { useEffect, useRef, useState } from "react";
import "./CSS/Home.css";
import change from "../assets/change.jpg";
import kids from "../assets/kids.jpg";
import AboutUs from './AboutUs';
import OurWork from './OurWork';
import soccer4 from '../assets/soccer4.jpg';
import soccer2 from '../assets/soccer2.jpg';
import stories from '../assets/stories.jpg';
import { useTranslation } from 'react-i18next';


function Home() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState({
    comingSoon: false,
    mission: false,
    stories: false,
    getInvolved: false,
  });

  const comingSoonRef = useRef(null);
  const missionRef = useRef(null);
  const storiesRef = useRef(null);
  const getInvolvedRef = useRef(null);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    const refs = [
      { key: 'comingSoon', ref: comingSoonRef },
      { key: 'mission', ref: missionRef },
      { key: 'stories', ref: storiesRef },
      { key: 'getInvolved', ref: getInvolvedRef },
    ];

    refs.forEach(({ key, ref }) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({ ...prev, [key]: true }));
          }
        },
        { threshold: 0.1 }
      );

      if (ref.current) {
        observer.observe(ref.current);
        observers.push(observer);
      }
    });

    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, []);

  return (
    <div className="home-container">
      <div className="hero-image">
        <div className="hero-overlay"></div>
        <iframe
          className="hero"
          src="https://www.youtube.com/embed/rBI0ecP7Q-Q?autoplay=1&mute=1&loop=1&playlist=rBI0ecP7Q-Q&controls=1"
          title="Elleny Foundation Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>

      <div ref={comingSoonRef} className={`coming-soon-wrapper ${isVisible.comingSoon ? 'fade-in-up' : ''}`}>
        <div className="coming-soon">
          <h2 className="gradient-text">{t("ComingSoon")}</h2>
          <a href="/gallery" className="learn-more modern-button">{t("Gallery")}</a>
        </div>
      </div>

      <section ref={missionRef} className={`mission ${isVisible.mission ? 'fade-in' : ''}`}>
        <div className="mission-container">
          <div className="mission-content">
            <div className="mission-image-wrapper">
              <img className="mission-image" src={change} alt="Mission" />
              <div className="image-shine"></div>
            </div>
            <div className="mission-text">
              <h2 className="section-title">{t("Mission")}</h2>
              <p className="section-description">
                {t("Missionparagraph3")}
              </p>
              <a href="/mission" className="learn-more modern-button">{t("LearnMore")}</a>
            </div>
          </div>
        </div>
      </section>

      <section ref={storiesRef} className={`stories ${isVisible.stories ? 'fade-in-up' : ''}`}>
        <div className="stories-container">
          <h1 className="section-title">{t("Gallery")}</h1>
          <p className="section-description">{t("GalleryDescription")}</p>
          <a href="/gallery" className="learn-more modern-button">{t("Gallery")}</a>
          <div className="story-images">
            <div className="story-image-wrapper">
              <img className="story-image" src={soccer4} alt="soccer" />
              <div className="image-overlay"></div>
            </div>
            <div className="story-image-wrapper">
              <img className="story-image" src={soccer2} alt="soccer" />
              <div className="image-overlay"></div>
            </div>
            <div className="story-image-wrapper">
              <img className="story-image" src={stories} alt="stories" />
              <div className="image-overlay"></div>
            </div>
          </div>
        </div>
      </section>

      <AboutUs />
      <OurWork />

      <section ref={getInvolvedRef} className={`get-involved ${isVisible.getInvolved ? 'fade-in' : ''}`}>
        <div className="container">
          <div className="get-involved-content">
            <div className="get-involved-text">
              <h2 className="section-title">{t("Contact")}</h2>
              <p className="section-description">{t("Contactparagraph")}</p>
              <a href="/getinvolved" className="learn-more modern-button">{t("Contact")}</a>
            </div>
            <div className="get-involved-image-wrapper">
              <img className="get-involved-image" src={kids} alt="Get Involved" />
              <div className="image-shine"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
